import { SlotTrakMachinesCommonServer } from "../../common/Server";

export const vsName = "slotTrakMachinesServer";
export const vsNgType = "service";

const modelUrl = "/api/machines/models";

export default class MachineServer extends SlotTrakMachinesCommonServer {
  constructor($http, $q, simpleQuery, simplePutOrPostSave, simpleDelete) {
    super($http, $q, simpleQuery, simplePutOrPostSave, simpleDelete);

    this.modelQuery = simpleQuery(modelUrl, { OrderBy: "Name" });
    this.modelSave = simplePutOrPostSave(modelUrl);
  }
}
MachineServer.$inject = [...SlotTrakMachinesCommonServer.$inject];
MachineServer.vsName = vsName;
MachineServer.vsNgType = vsNgType;
